import '../styles.scss';
import React from 'react';
import track from 'react-tracking';
import PropTypes from 'prop-types';
import { Container } from '@edx/paragon';

import InstructorCard from '../components/InstructorCard';

function BaseInstructorsMobile({ staff }) {
  return (
    <Container size="sm">
      <div className="instructors mt-3 d-flex flex-column justify-content-center">
        <div className="instructor-cards">
          {staff.map(instructor => (
            <InstructorCard
              {...instructor}
              key={instructor.uuid}
            />
          ))}
        </div>
      </div>
    </Container>
  );
}

BaseInstructorsMobile.propTypes = {
  staff: PropTypes.arrayOf(PropTypes.shape(
    InstructorCard.propTypes,
    {
      uuid: PropTypes.string,
    },
  )),
  refProp: PropTypes.shape().isRequired,
};

BaseInstructorsMobile.defaultProps = {
  staff: [],
};

const Instructors = track({
  component: 'Instructors',
})(BaseInstructorsMobile);

export default Instructors;
